(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity/assets/react/shared-components/doc-item.js') >= 0) return;  svs.modules.push('/modules/terms-integrity/assets/react/shared-components/doc-item.js'); 'use strict';

const {
  ListItem
} = svs.ui.ReactListGroup;
const {
  ReactIcon: Icon
} = svs.ui;
const displaySize = (bytes, documentMime) => {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  let fileType = 'pdf';
  if (documentMime) {
    fileType = documentMime.split('/')[1];
  }
  if (bytes === 0) {
    return '';
  }
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
  if (i === 0) {
    return "".concat(fileType, ", ").concat(bytes, " ").concat(sizes[i]);
  }
  return "".concat(fileType, ", ").concat((bytes / 1024 ** i).toFixed(0), " ").concat(sizes[i]);
};
const DocItem = _ref => {
  var _svs, _svs$core, _svs$core$config, _svs$core$config$data, _svs$core$config$data2;
  let {
    docItem
  } = _ref;
  const {
    title,
    documentSize,
    documentUrl
  } = docItem;
  const cdn = (_svs = svs) === null || _svs === void 0 ? void 0 : (_svs$core = _svs.core) === null || _svs$core === void 0 ? void 0 : (_svs$core$config = _svs$core.config) === null || _svs$core$config === void 0 ? void 0 : (_svs$core$config$data = _svs$core$config.data) === null || _svs$core$config$data === void 0 ? void 0 : (_svs$core$config$data2 = _svs$core$config$data.svsconfig) === null || _svs$core$config$data2 === void 0 ? void 0 : _svs$core$config$data2.cdn2;
  return React.createElement(ListItem, null, React.createElement("a", {
    className: "u-text-reset u-flex u-flex-no-wrap u-flex-align-items-center",
    href: cdn + documentUrl,
    rel: "noreferrer",
    target: "_blank"
  }, React.createElement(Icon, {
    className: "left block",
    icon: "document",
    size: "100"
  }), React.createElement("div", {
    className: "margin-xs-h-1 u-flex-fill"
  }, title), React.createElement("div", {
    className: "align-right terms-integrity-no-wrap"
  }, displaySize(documentSize))));
};


svs.termsIntegrity.sharedComponents.DocItem = DocItem;
 })(window);